
import { Component, Input, inject } from '@angular/core';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Store } from '@ngrx/store';
import { getDatepickerConfig } from '@aston/foundation';
import { SubsidiariesStoreActions } from 'apps/console/src/app/root-store/subsidiaries-store';
import { AccessLevel } from 'apps/console/src/app/shared-module/enums';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';
import { AppStoreSelectors } from 'apps/console/src/app/root-store/app-store';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { ISubsidiaryListItem } from '../../models';

@Component({
	selector: 'subsidiaries-list',
	templateUrl: './subsidiaries-list.component.html',
	imports: [AsyncPipe, TranslateModule, NgbDropdownModule, BsDatepickerModule, NgbTooltipModule, RouterModule,],
	styles: `
		input.invisible { width: 1px; }
	`
})
export class SubsidiariesListComponent {
	private store = inject(Store);


	@Input() hasPendingSubsidiaries: boolean;
	@Input() subsidiaries: ISubsidiaryListItem[];

	currentUserIsSupport$ = this.store.select(AppStoreSelectors.selectCurrentUserIsSupport);

	accessLevel = AccessLevel;
	minDate: Date = new Date();
	bsConfig: BsDatepickerConfig = {
		...getDatepickerConfig(),
		dateInputFormat: 'YYYY-MM-DD',
	};

	timeoutTenant(id: number, value: string) {
		this.store.dispatch(SubsidiariesStoreActions.SetTenantTimeoutConfirm({ entity: { id, date: value ? new Date(value) : null }}))
	}

	redirectToTenant(subsidiaryId: number) {
		this.store.dispatch(SubsidiariesStoreActions.RedirectToTenant({subsidiaryId}))
	}

	redirectToTenantNewTab(subsidiaryId: number) {
		this.store.dispatch(SubsidiariesStoreActions.RedirectToTenantNewTab({subsidiaryId}))
	}

	getSubsidiaryDetailPath(id: number) {
		return RoutesDefinitions.getSubsidiaryDetailFullPath(id);
	}
}
